import { createReducer } from './util';
import {
  ADD_RESULT_HISTORY,
  APPEND_RESULT_HISTORY_LIST, SET_END_STATE, SET_LOADING_STATE,
} from '../actions/result-history';

export const resultHistoryInitialState = {
  resultHistory: {
    list: [],
    records: {},
    loading: false,
    end: false,
  }
};

export const resultHistory = createReducer(
  resultHistoryInitialState.resultHistory,
  {
    [APPEND_RESULT_HISTORY_LIST]: (state, { results }) => (
      { list: [...state.list, ...results] }
    ),
    [ADD_RESULT_HISTORY]: (state, { result }) => (
      { records: { ...state.records, [result.id]: result } }
    ),
    [SET_LOADING_STATE]: (_, { loading }) => (
      { loading }
    ),
    [SET_END_STATE]: (_, { end }) => (
      { end }
    )
  }
);



// WEBPACK FOOTER //
// ./src/reducers/result-history.js